import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChartPie, FaPlusCircle, FaMoneyBill, FaTasks, FaRegFilePdf, FaMoneyBillWave, FaReceipt, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import { MdCheckCircle, MdAttachMoney, MdPerson, MdAccountBalanceWallet } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { FcSalesPerformance } from "react-icons/fc";
import "./EmployeeSidebar.css";

import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
const iconMap = {
  "Employee Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Perfomance": <FcSalesPerformance style={{ color: "#FEB941" }} />,
  "Salary Slip": <FaReceipt style={{ color: "#FEB941" }} />,
  "Loan Management": <FaMoneyBillWave style={{ color: "#A8DF8E" }} />,
  "Expense Tracking": <FaMapMarkerAlt style={{ color: "green" }} />,
  "Profile": <MdPerson style={{ color: "Aqua" }} />,
  "Attendance Management": <FaCalendarAlt style={{ color: "yellow" }} />,
  "Expense Management": <FaMoneyBill style={{ color: "Plum" }} />,
  "Contract": <MdAttachMoney style={{ color: "green" }} />,
  "Add Leave/WFH": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
  "Leave Approval": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
  "Create Work Space": <FaPlusCircle style={{ color: "orange" }} />,
  "Work Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Task Overview": <FaTasks style={{ color: "pink" }} />,
  "File": <FaReceipt style={{ color: "#FEB941" }} />,
  "Policy": <FaRegFilePdf style={{ color: "red" }} />,
  "EPF": <MdAccountBalanceWallet style={{ color: "pink" }} />,
  "Settings": <IoMdSettings style={{ color: "yellow" }} />,
};

const employeeLinks = [
  {
    to: "/Employee/dashboard",
    name: "Employee Dashboard",
    moduleName: "Profile Management",
    roleName: "View Profile",
  },
  { to: "/Employee/performance", name: "Perfomance" },
  { to: "/Employee/salary-slip", name: "Salary Slip" },
  { to: "/Employee/loan-management", name: "Loan Management" },
  { to: "/Employee/expense-tracking", name: "Expense Tracking" },
  { to: "/Employee/profile", name: "Profile" },
  {
    to: "/Employee/attendance-management",
    name: "Attendance Management",
    moduleName: "Attendance Management",
    roleName: "View Attendance",
  },
  { to: "/Employee/expense-management", name: "Expense Management" },
  // { to: "/Employee/Contract", name: "Contract" },
  { to: "/Employee/add-leave-wfh", name: "Add Leave/WFH" },
  {
    to: "/Employee/Leave-approval",
    name: "Leave Approval",
    moduleName: "Leave Approval",
    roleName: "Leave Approval",
  },
  { to: "/Employee/create-workspace", name: "Create Work Space" },
  {
    to: "/Employee/work-dashboard",
    name: "Work Dashboard",
    moduleName: "Workspace Management",
    roleName: "View Workspace",
  },
  {
    to: "/Employee/task-overview",
    name: "Task Overview",
    moduleName: "Task Overview",
    roleName: "Task Overview",
  },
  { to: "/Employee/file", name: "File" },
  {
    to: "/Employee/policy",
    name: "Policy",
    moduleName: "Policy Management",
    roleName: "View Policy",
  },
  { to: "/Employee/EPF", name: "EPF" },
  { to: "/Employee/setting", name: "Settings" },
];

const employeeGroups = [
  { title: "Overview", items: ["Employee Dashboard"] },
  { title: "People & Attendance", items: ["Profile", "Attendance Management", "Add Leave/WFH", "Leave Approval", "Perfomance"] },
  { title: "Work & Projects", items: ["Work Dashboard", "Create Work Space", "Task Overview", "File"] },
  { title: "Payroll & Finance", items: ["Salary Slip", "Expense Management", "Expense Tracking", "Loan Management", "EPF"] },
  { title: "Organization", items: ["Policy"] },
  { title: "Administration", items: ["Settings"] },
];

const EmployeeSidebar = () => {
  const { pathname } = useLocation();
  const { user, accessDataemp, setAccessemployeData } =
    useContext(GlobalContext);

  const fetchAccessData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetAccessManagementAdmin`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
        },
      );
      const data = await res.json();
      if (data.status === "0") setAccessemployeData(data.data);
    } catch (e) {
      console.error(e);
    }
  };
  // useEffect(() => {
  //   console.log("ACCESS DATA ✅", accessDataemp);
  // }, [accessDataemp]);

  useEffect(() => {
    if (user?.firm_id && user?.userid) fetchAccessData();
  }, [user]);

  const navigationLinks = employeeLinks.filter((link) => {
    if (link.moduleName && link.roleName) {
      const moduleData = accessDataemp?.find((m) => m.module_name === link.moduleName);
      const dataArray = Array.isArray(moduleData?.data) ? moduleData.data : [];
      return !!dataArray.find((r) => r.role_name?.trim() === link.roleName?.trim() && r.access === "Y");
    }
    return true;
  });
  return (
    <nav className="employee-sidebar" aria-label="Employee navigation">
      <h5 className="employee-sidebar-title">Employee System</h5>
      {employeeGroups.map(group => {
        const links = group.items.map(name => navigationLinks.find(link => link.name === name)).filter(Boolean);
        if (!links.length) return null;
        return (
          <section className="employee-sidebar-group" key={group.title} aria-label={group.title}>
            <h6 className="employee-sidebar-group-title">{group.title}</h6>
            <ul className="employee-sidebar-links">
              {links.map(link => {
                const active = pathname === link.to;
                return (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className={`employee-sidebar-link${active ? " is-active" : ""}`}
                      aria-current={active ? "page" : undefined}
                    >
                      <span className="employee-sidebar-icon" aria-hidden="true">{iconMap[link.name] || null}</span>
                      <span className="employee-sidebar-label">{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </section>
        );
      })}
    </nav>
  );
};

export default EmployeeSidebar;
